// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6069ff5","453":"e9414621","455":"9b3de071"}[chunkId] + ".chunk.js";
};